<template>
  <div class="row">
    <div class="col-12">
      <section class="card shadow w3-white mb-4">
        <div class="card-body m-0 bg-transparent">
          <div class="row mb-2">
            <div class="col-sm-5">
              <router-link class="w3-text-red my-0 mr-3 w3-left" to="hmo">
                <span><i class="bx bx-arrow-back"></i> Back</span>
              </router-link>
              <h4 class="bold w3-left clearfix my-0">HIW Transactions</h4>
            </div>
            <div class="col-sm-7">
              <div class="w3-right">
                <DateRangeFilter @gettransactions="getTransactions" />
              </div>
            </div>
          </div>
          <div v-if="fetching">
            <img class="mr-3" src="base/img/loading.gif" width="40" />
            Loading transactions
          </div>
          <div v-else>
            <DataTable
              v-if="Transactions?.length > 0"
              :tableid="'HiwEnrollees'"
              :headers="TableHeader"
              :rows="Rows"
              sort="[[0, 'asc']]"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import { useStore } from "vuex";
import { computed, onBeforeMount, ref, watchEffect } from "vue";
import { formatCurrency } from "@/helpers/utilities";
import DataTable from "@/components/DataTable.vue";
import DateRangeFilter from "@/components/DateRangeFilter";
export default {
  components: { DataTable, DateRangeFilter },
  setup() {
    const store = useStore();
    const fetching = computed(() => store.state.fetching.HMOTransactions);

    const Period = ref({
      StartDate: "",
      EndDate: "",
    });
    const Transactions = computed(() => store.state.HMOTransactions);
    if (!Transactions.value?.length) {
      store.dispatch("HMOTransactions", {
        StartDate: "",
        EndDate: "",
      });
    }

    const TableHeader = [
      { key: "PostingDate", text: "Posting Date", type: "date" },
      { key: "EntryNo", text: "Entry No" },
      { key: "HMOAmount", text: "Amount", type: "currency" },
      { key: "AmountRecv_", text: "Amount Received", type: "currency" },
      { key: "Description", text: "Description" },
      { key: "Vendor", text: "Vendor" },
      // { key: "Margin", text: "Margin" },
    ];
    const Rows = ref([]);
    watchEffect(() => {
      if (Transactions.value && Transactions.value.length) {
        for (let i = 0; i < Transactions.value.length; i++) {
          Rows.value[i] = {};
          let transaction = Transactions.value[i];
          for (const key in transaction) {
            Rows.value[i][key] = {};
            Rows.value[i][key]["value"] = transaction[key];
            for (const head in TableHeader) {
              if (key === TableHeader[head].key) {
                Rows.value[i][key]["class"] = TableHeader[head].class ?? "";
                switch (TableHeader[head].type) {
                  case "currency":
                    Rows.value[i][key]["value"] = formatCurrency(
                      transaction[key],
                      "&#8358;"
                    );
                    break;
                  case "date":
                    Rows.value[i][key]["value"] =
                      transaction[key].split("T")[0];
                    break;
                }
              }
            }
          }
        }
      }
    });
    const getTransactions = (period) => {
      store.dispatch("HMOTransactions", {
        StartDate: period.StartDate,
        EndDate: period.EndDate,
      });
    };
    onBeforeMount(() => {
      store.dispatch("resetIdleTime");
    });

    return {
      Transactions,
      TableHeader,
      Rows,
      fetching,
      getTransactions,
      Period,
    };
  },
};
</script>